import React, { useEffect, useState } from "react";

import { Button, Form, Input, Toast } from "antd-mobile-v5";
import { getQueryString } from "../../../util/getQueryString";
import instance from "../../../util/axios";

const uuid: string = getQueryString("uuid") || "";
const userId: string = getQueryString("userId") || "";
export default function AddInfo() {
  const [title, setTitle] = useState("");
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    if (uuid) {
      instance
        .get(
          `/custom/groundPushing/getSalespersonInfo?userId=${userId}&taskId=${uuid}&token=1cb41f4c02fb4e40a367b9a80c620a7e-4aef5b9189a54cc08993204d8df6c222-78bd034fd09ceda17a925471cfbeb108`
        )
        .then((resp) => {
          if (resp.data.Status === "1") {
            const data = resp.data.Data;
            form.setFieldsValue({
              advisor: data.name,
              advisorMobile: data.mobile,
              product: data.product,
            });
            setTitle(data.product);
          }
        });
    }
  }, [form]);
  const onFinish = (values: any) => {
    console.log(values);
    setDisabled(true);
    instance
      .post(
        `/custom/groundPushing/placeOrder?token=1cb41f4c02fb4e40a367b9a80c620a7e-4aef5b9189a54cc08993204d8df6c222-78bd034fd09ceda17a925471cfbeb108`,
        { ...values, taskId: uuid, userId: userId }
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          window.location.href = resp.data.Data;
          // window.open(resp.data.Data);
        } else {
          Toast.show(resp.data.Data);
        }
        setDisabled(false);
      });
  };

  return (
    <>
      <div style={{ fontSize: 16, fontWeight: "bold", padding: 16 }}>
        {title}
      </div>
      <Form
        layout="horizontal"
        name="form"
        form={form}
        onFinish={onFinish}
        footer={
          <Button
            block
            type="submit"
            color="primary"
            size="large"
            disabled={disabled}
          >
            提交
          </Button>
        }
      >
        <Form.Item name="advisor" label="业务员">
          <Input disabled />
        </Form.Item>
        <Form.Item name="advisorMobile" label="业务员手机号">
          <Input disabled />
        </Form.Item>
        <Form.Item name="product" label="产品">
          <Input disabled />
        </Form.Item>
        <Form.Item
          name="name"
          label="姓名"
          rules={[{ required: true, message: "姓名不能为空" }]}
        >
          <Input placeholder="请输入姓名" />
        </Form.Item>
        <Form.Item
          name="idCard"
          label="身份证"
          rules={[{ required: true, message: "身份证号不能为空" }]}
        >
          <Input placeholder="请输入身份证号" />
        </Form.Item>
        <Form.Item
          name="mobile"
          label="手机号"
          rules={[
            { required: true, message: "手机号不能为空" },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "手机号格式错误",
            },
          ]}
        >
          <Input placeholder="请输入手机号" />
        </Form.Item>
      </Form>
    </>
  );
}
